/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import getEnv from 'src/env/enviroment';
import { ScriptStatus, useScript } from 'src/helpers/hooks';

export const CoviePage = ({
  onSuccess,
  onError,
  onStepChange,
  onDocumentUpload,
  metaData,
  activeCovieLink,
}: {
  onSuccess?: (a: any) => void;
  onError?: (a: any) => void;
  onStepChange?: (a: any) => void;
  onDocumentUpload?: (a: any) => void;
  metaData?: { [key: string]: any };
  activeCovieLink?: string | null;
}) => {
  const covieScriptStatus = useScript(
    'https://access.covie.io/sdk/covie-access.js',
  );
  const [error, setError] = useState('');

  useEffect(() => {
    if (covieScriptStatus === ScriptStatus.ERROR) {
      setError('Error while script loading');
    }
  }, [covieScriptStatus]);

  useEffect(() => {
    if (
      covieScriptStatus === ScriptStatus.READY &&
      (window as any).CovieAccess &&
      !error
    ) {
      (window as any).CovieAccess.init({
        elementId: 'covie-root',
        integrationKey: getEnv().covie_secret,
        linkId: activeCovieLink,
        width: '100%',
        height: '700',
        linkMetadata: metaData,
        onInit: function (linkId: any) {
          console.log(linkId);
        },
        onSuccess: function (linkId: any, embedPolicies: any) {
          if (Array.isArray(embedPolicies) && embedPolicies.length) {
            onSuccess && onSuccess(embedPolicies[0]);
          }
        },
        onDocumentUpload: function (linkId: any, link: string) {
          onDocumentUpload && onDocumentUpload(link);
        },
        onStepChange: function (linkId: any, step: any) {
          onStepChange && onStepChange(step);
        },
        onLinkError: function (linkId: any, error: any) {
          onError && onError(error);
        },
        hide: [],
      });
    }
  }, [covieScriptStatus, error, onError, onStepChange, onSuccess]);

  return (
    <div className="w-100">
      <div id="covie-root" style={{ height: 700 }}></div>
      {!!error &&
        'We are having some trouble, Please contact support for help.'}
    </div>
  );
};
